const IMAGE_FILE_PATTERN = /\.(avif|bmp|gif|jpe?g|png|svg|webp)$/i;

export const isMarkdownFile = file =>
  Boolean(file && /\.md$/i.test(file.name || ""));

export const isImageFile = file =>
  Boolean(
    file &&
      ((file.type && file.type.startsWith("image/")) ||
        IMAGE_FILE_PATTERN.test(file.name || ""))
  );

export const readMarkdownFiles = (fileList, onLoad, onError = () => {}) => {
  const files = Array.from(fileList || []);
  const markdownFile = files.find(isMarkdownFile);
  if (!markdownFile) {
    onError(new Error("Choose a Markdown file."));
    return false;
  }

  const imageFiles = files.filter(isImageFile);
  const reader = new FileReader();
  reader.onload = event => {
    if (event.target.error) {
      onError(event.target.error);
      return;
    }
    onLoad(event.target.result, markdownFile, imageFiles);
  };
  reader.onerror = () =>
    onError(reader.error || new Error("Error while reading file."));
  reader.readAsText(markdownFile);
  return true;
};
